import { observer } from 'mobx-react';
import './WinPopup.scss';
import winBackground from '../../assets/images/win-background.png';
import { gameStore, userStore, useTranslation } from '../../platform/stores';
import { c } from '../../platform/utils';

export const WinPopup = observer(() => {
  const t = useTranslation();
  const { language } = gameStore;
  const { lastWin, lastWinClone, currency } = userStore;
  return (
    <div className={`win-popup-component ${lastWin ? 'visible' : ''}`}>
      <div className="win-popup-content">
        <img src={winBackground} alt="Win background"/>
        <div className={`title ${language === 'ru' ? 'ru' : ''}`}>{t('YOU_WIN')}</div>
        <div className="win-amount">{c(lastWinClone, currency)}</div>
      </div>
    </div>
  );
});
